<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="City Preview"
      id="admin_edit_city_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="
          '/admin/locations/cities/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove City
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="city.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605887387/botswana%20services/website%20assets/bots_city_bjdd8s.jpg'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Edit City Form"
      id="admin_edit_city_form"
    ></CardedSectionHeader>
    <AdminCitiesAdd
      @on-show-loader="show_loader"
      @on-hide-loader="hide_loader"
      :is_editing="true"
      :is_loading="is_loading"
      ref="add_city_form_comp_ref"
      @on-success-edit="on_success_edit"
    >
    </AdminCitiesAdd>
  </div>
</template>
<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminCitiesAdd from "./AdminCitiesAdd";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminCitiesEdit",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    AdminCitiesAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      city: {
        id: 0,
        name: "",
        short_name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        }
      },
    };
  },
  methods: {
    show_loader() {
      this.$emit("on-show-loader");
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    load_city(){
      ServerClient.Locations.get_city(
      {
        id: this.$route.params.id,
        is_edit: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.city = res;
        var edit = {
            ...res
        };
        delete edit.country;
        delete edit.district;
        this.$refs.add_city_form_comp_ref.fill_edit_city(edit);
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading city details on admin edit city",
          errors
        );
      }
    );
    },
    on_success_edit(){
      this.load_city();
    }
  },

  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Short Name",
          val: this.city.short_name,
        },
        { text: "District:", val: this.city.district.name },
        { text: "Country:", val: this.city.country.name },
      ];
      return facts;
    },
  },

  mounted() {
    var city_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Edit City",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Cities",
          disabled: false,
          href: "/admin/locations/cities/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/cities/list/view/" + city_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:"/admin/locations/cities/list/view/"+city_id+"/edit" 
        }
      ],
      navbar_cols: 3
    });
    this.load_city();
  },
};
</script>

